/**
 * 地図シェルに載せる 1 画面ぶんの中身
 *
 * 地図と常設シートはシェルが持ち続けるので、画面側は「何を重ねて何を書くか」だけを返す。
 * スタンプラリーとルートプランで同じ地図インスタンスを使い回すための取り決め。
 */

import type { ReactNode } from 'react'

import type { ActionSection } from '@/components/ui/custom-dropdown'

export type MapScreen = {
  title: string
  menuSections: ActionSection[]
  /** 絞り込みバーより前に出す帯。通知から来たときの案内など */
  banner?: ReactNode
  filterBar?: ReactNode
  /** 地図に重ねるマーカーと経路。GoogleMapCanvas の子として描かれる */
  mapLayer: ReactNode
  /** 地図の上に絶対配置する UI。選択中の実行ボタンなど */
  mapOverlay?: ReactNode
  onMapClick?: () => void
  /** 地図を合わせたい範囲。fitKey が変わったときだけ合わせ直す */
  fitPoints: google.maps.LatLngLiteral[]
  fitKey: string
  sheetHeader: ReactNode
  sheetBody: ReactNode
  /** 常設シートの外に出すダイアログ。共有設定など */
  dialogs?: ReactNode
}

/** シートの高さ。全高でもヘッダーの操作が押せるよう上を残す */
export const SHEET_SNAP = { peek: 0.16, half: 0.52, full: 0.88 }
export const SHEET_SNAP_POINTS = [SHEET_SNAP.peek, SHEET_SNAP.half, SHEET_SNAP.full]
export type SheetSnap = typeof SHEET_SNAP
